var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.59996 2.82701C7.05885 2.7196 7.52867 2.6659 7.99996 2.66701C12.6666 2.66701 15.3333 8.00034 15.3333 8.00034C14.9286 8.75741 14.446 9.47017 13.8933 10.127M9.41329 9.41367C9.23019 9.61017 9.00939 9.76778 8.76406 9.87709C8.51873 9.9864 8.25389 10.0452 7.98535 10.0499C7.71681 10.0547 7.45007 10.0053 7.20103 9.90467C6.952 9.80408 6.72577 9.65436 6.53586 9.46444C6.34594 9.27453 6.19622 9.0483 6.09563 8.79927C5.99504 8.55023 5.94564 8.28349 5.95038 8.01495C5.95512 7.74641 6.0139 7.48157 6.12321 7.23624C6.23252 6.99091 6.39013 6.77011 6.58663 6.58701M11.96 11.9603C10.8204 12.829 9.4327 13.3103 7.99996 13.3337C3.33329 13.3337 0.666626 8.00034 0.666626 8.00034C1.49589 6.45494 2.64605 5.10475 4.03996 4.04034L11.96 11.9603Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 0.666992L15.3333 15.3337",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.e1043af87257b1e238422896e2c3cae0.svg";
export { ForwardRef as ReactComponent };